export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8323.109e247c.jpg";